export default __webpack_public_path__ + "static/media/bellRedDot.4a37f4df.svg";